const HEADER_FOOTER_LOADING = "HEADER_FOOTER_LOADING";
const HEADER_FOOTER_ERROR = "HEADER_FOOTER_ERROR";
const HEADER_FOOTER_SUCCESS = "HEADER_FOOTER_SUCCESS";

export { HEADER_FOOTER_LOADING, HEADER_FOOTER_ERROR, HEADER_FOOTER_SUCCESS };